import { Component, OnInit } from '@angular/core';
import { AlertaService } from '../../../services/alerta.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TipoAlertaDto } from '../../../dto/alerta/tipo-alerta.dto';
import { TranslateService } from "@ngx-translate/core";
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-gestion-alertas',
  templateUrl: './gestion-alertas.component.html',
  styleUrls: ['./gestion-alertas.component.scss'],
})
export class GestionAlertasComponent implements OnInit {
  alertas: TipoAlertaDto[] = [];
  variablesArray: string[] = [];
  selectedAlertaId: number | null = null;
  editableDetalle = '';
  detalleEditado = false;
  // Multilenguaje
  alertasText: any = {};
  constructor(
    private readonly alertaService: AlertaService,
    private readonly alertService: AlertaModalService,
    private readonly translate: TranslateService,
    private readonly notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.obtenerTodasLasAlertas();
    this.translate.stream('alertas-plataforma').subscribe(text => {
      this.alertasText = text;
    });
  }

  obtenerTodasLasAlertas() {
    this.alertaService.obtenerTodasLasAlertas().subscribe({
      next: response => {
        this.alertas = response.data;

        if (this.alertas.length > 0) {
          this.selectedAlertaId = this.alertas[0].Id;
          this.editableDetalle = this.alertas[0].Descripcion || '';
          this.updateVariables();
        }
      },
      error: err => this.notificationService.addNotification('error','Error al obtener las alertas'),
    });
  }

  updateVariables(): void {
    const alertaSeleccionada = this.alertas.find(
      alerta => alerta.Id === Number(this.selectedAlertaId)
    );
    // Obtener y procesar las variables de la alerta seleccionada
    const variablesString = alertaSeleccionada?.Variables || '';
    this.variablesArray = variablesString
      .split(',')
      .map(variable => variable.trim())
      .filter(variable => variable)
      .map(variable => `#{${variable}}`);
  }

  onAlertaChange() {
    const alertaSeleccionada = this.alertas.find(
      alerta => alerta.Id === Number(this.selectedAlertaId)
    );

    if (alertaSeleccionada) {
      this.editableDetalle = alertaSeleccionada.Descripcion || '';
    } else {
      this.editableDetalle = '';
    }
    this.updateVariables();
    this.detalleEditado = false;
  }

  onDetalleEdit() {
    this.detalleEditado = true;
  }

  guardarCambios() {
    if (this.selectedAlertaId !== null) {
      const alertaActualizada = {
        Id: this.selectedAlertaId,
        Descripcion: this.editableDetalle,
      };

      this.alertaService.actualizarAlerta(alertaActualizada).subscribe({
        next: () => {
          this.alertService.exito(this.alertasText['exito']);
          this.obtenerTodasLasAlertas();
          this.detalleEditado = false;
        },
        error: err => this.notificationService.addNotification('error', this.alertasText['error']),
      });
    }
  }
}
